import { RootState } from 'store/root-reducer';

import { User, UserLogActivity } from 'store/user/types';

export const getUsers = (state: RootState): User[] | null => state.admin.users.entities;
export const getUserActivityLogs = (state: RootState): UserLogActivity[] | null => state.admin.users.activityLogs;
export const isUsersLoading = (state: RootState): boolean => state.admin.users.isLoading;
export const isUpdateUserLoading = (state: RootState): boolean => state.admin.users.isUpdatedUserLoading;
export const isCreateUserLoading = (state: RootState): boolean => state.admin.users.isCreateUserLoading;
export const isUserActivityLogsLoading = (state: RootState): boolean => state.admin.users.isActivityLogsLoading;
export const getActions = (state: RootState): string[] | null => state.admin.users.actions;
export const getModules = (state: RootState): string[] | null => state.admin.users.modules;
